ObjectUtils.define('UIFrontPageNavigationController', UIController, {

  enableDebug: 0,
  HEIGHT_REGULAR: 100, // Matches css for `.UIFrontPageNavigation .navigationTabContainer`
  HEIGHT_COLLAPSED: 60, // Matches css for `.UIFrontPageNavigation.collapsed .navigationTabContainer`
  _reviewData: null,
  _currentReviewIndex: 0,
  _refreshInterval: 5000,

  didLoad: function didLoad(container, data) {
    Assert.TRUTHY(data.reviews, 'Expected non-empty reviews');
    this._reviewData = data.reviews;
    setInterval(FunctionUtils.bind(this, this._updateReview, container), this._refreshInterval);

    EventDelegater.registerScrollHandler(FunctionUtils.bind(this, this._didScroll, container));
  },

  _didScroll: function _didScroll(container, eventData) {
    var scrollTop = eventData.scrollTop;
    var headerContainer = DOM.findBySelector('.UIPageHeader');
    var headerSize = DOM.size(headerContainer);
    var availableHeaderHeight = headerSize.height - scrollTop;

    this.enableDebug && Logger.log(this, 'Did scroll', {
      scrollTop: scrollTop,
      headerHeight: headerSize.height,
      availableHeaderHeight: availableHeaderHeight,
    });
    if (availableHeaderHeight <= this.HEIGHT_COLLAPSED) {
      DOM.addClass(container, 'collapsed');
      DOM.removeClass(container, 'collapsing');
    } else if (availableHeaderHeight <= this.HEIGHT_REGULAR + this.HEIGHT_COLLAPSED) {
      DOM.removeClass(container, 'collapsed');
      DOM.addClass(container, 'collapsing');
    } else {
      DOM.removeClass(container, 'collapsed');
      DOM.removeClass(container, 'collapsing');
    }

    var contentElementClasses = {
      'UIFrontPageReviews': 'navReviewsContainer',
      'UIFrontPageSecurity': 'navSecurityContainer',
      'UIFrontPageFeatures': 'navFeaturesContainer'
    };
    var selectedTabClass = 'navFeaturesContainer';
    ArrayUtils.each(contentElementClasses, FunctionUtils.bind(this, function(contentElementClass, navTabClass) {
      var contentContainer = DOM.findBySelector('.'+contentElementClass);
      var contentContainerOffset = contentContainer.offset().top - this.HEIGHT_COLLAPSED - 20;

      if (scrollTop >= contentContainerOffset) {
        selectedTabClass = navTabClass;
        return false;
      }
    }));

    var collapsedContentContainer = DOM.findByClass(container, 'collapsedContentContainer');
    var selectedTab = DOM.findByClass(collapsedContentContainer, selectedTabClass);
    this._setSelectedTab(container, selectedTab);
  },

  _getCurrentSelectedTab: function _getCurrentSelectedTab(container) {
    var selectedTab;
    var collapsedContentContainer = DOM.findByClass(container, 'collapsedContentContainer');
    var navigationTabs = DOM.findAllByClass(collapsedContentContainer, 'navigationTabContainer');
    ArrayUtils.each(navigationTabs, function(index, navigationTab) {
      if (DOM.hasClass(navigationTab, 'selectedNavigation')) {
        selectedTab = navigationTab;
        return false;
      }
    });

    return selectedTab;
  },

  _setSelectedTab: function _setSelectedTab(container, selectedNavigationTab) {
    var selectedTab = this._getCurrentSelectedTab(container);
    if (selectedTab) {
      DOM.removeClass(selectedTab, 'selectedNavigation');
    }

    if (selectedNavigationTab) {
      DOM.addClass(selectedNavigationTab, 'selectedNavigation');
    }
  },

  didClick: function didClick(container, target) {
    var signupLink = DOM.maybeFindParentByClass(target, 'navSignupContainer');
    if (signupLink) {
      return EventDelegater.FORWARD;
    }

    var offset, selectedNavigationTab;
    if (DOM.maybeFindParentByClass(target, 'navLogoContainer')) {
      offset = 0;
      selectedNavigationTab = null;
    } else {
      selectedNavigationTab = DOM.maybeFindParentByClass(target, 'navigationTabContainer');

      if (!selectedNavigationTab) {
        return EventDelegater.FORWARD;
      }

      var scrollElementClass;
      if (DOM.hasClass(selectedNavigationTab, 'navFeaturesContainer')) {
        scrollElementClass = 'UIFrontPageFeatures';
      } else if (DOM.hasClass(selectedNavigationTab, 'navSecurityContainer')) {
        scrollElementClass = 'UIFrontPageSecurity';
      } else if (DOM.hasClass(selectedNavigationTab, 'navReviewsContainer')) {
        scrollElementClass = 'UIFrontPageReviews';
      }
      var scrollToElem = DOM.findBySelector('.'+scrollElementClass);
      offset = scrollToElem.offset().top - this.HEIGHT_COLLAPSED;
    }

    var shouldAnimateScroll = true;
    DOM.setPageScrollOffsetWithAnimation(offset, shouldAnimateScroll);

    return EventDelegater.STOP;
  },

  _updateReview: function _updateReview(container) {
    var regularContentContainer = DOM.findByClass(container, 'regularContentContainer');
    var reviewsContainer = DOM.findByClass(regularContentContainer, 'navReviewsContainer');
    var reviewTitleContainer = DOM.findByClass(reviewsContainer, 'navSubtitleContainer');

    if (DOM.hasClass(container, 'collapsing') || DOM.hasClass(container, 'collapsed')) {
      DOM.hide(reviewTitleContainer);
      return;
    }

    var reviewContainer = DOM.findByClass(reviewsContainer, 'reviewContainer');
    var previousReviewData = this._reviewData[this._currentReviewIndex];

    reviewTitleContainer.fadeOut({
      // duration: 10000,
      complete: FunctionUtils.bind(this, function() {
        ++this._currentReviewIndex;
        if (this._currentReviewIndex >= this._reviewData.length) {
          this._currentReviewIndex = 0;
        }

        var reviewData = this._reviewData[this._currentReviewIndex];

        DOM.setInnerHtml(reviewTitleContainer, '"'+reviewData.title+'"');
        DOM.removeClass(reviewContainer, previousReviewData.className);
        DOM.addClass(reviewContainer, reviewData.className);

        reviewTitleContainer.fadeIn({
          // duration: 10000,
        });
      })
    });
  }
});
